export default __webpack_public_path__ + "static/media/icon-facebook.101bd07e.svg";